import axios from 'axios'
import Vue from 'vue'

// initial state
const state = {
}

// getters
const getters = {}

// actions
const actions = {
    ADD_ITEMS_TO_LIST({ COMMIT }, obj) {
        var vm = this;
        vm.commit("errors/CLEAR_ERRORS");

        return axios
            .all([
                axios.post(
                    "/rest/model/shoppinglist/additem", obj
                )
            ])
            .then(
                axios.spread((response) => {
                    return response
                })
            )
            .catch((response) => {
                return response
            });
    },
}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
